/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  DashboardCreatePlatform,
  DashboardPlatformAccessible,
  DashboardPlatformAvailable,
  DashboardPlatformCountResult,
  DashboardPlatformDetail,
  DashboardPlatformList,
  DashboardPlatformSearchResult,
  DashboardPlatformsControllerAccessibleCount400,
  DashboardPlatformsControllerAccessibleCount401,
  DashboardPlatformsControllerAccessibleCount429,
  DashboardPlatformsControllerAccessibleCountParams,
  DashboardPlatformsControllerAccessibleSearch200,
  DashboardPlatformsControllerAccessibleSearch400,
  DashboardPlatformsControllerAccessibleSearch401,
  DashboardPlatformsControllerAccessibleSearch429,
  DashboardPlatformsControllerAccessibleSearchParams,
  DashboardPlatformsControllerAvailableByPublicId400,
  DashboardPlatformsControllerAvailableByPublicId401,
  DashboardPlatformsControllerAvailableByPublicId404,
  DashboardPlatformsControllerAvailableByPublicId429,
  DashboardPlatformsControllerAvailableCount400,
  DashboardPlatformsControllerAvailableCount401,
  DashboardPlatformsControllerAvailableCount429,
  DashboardPlatformsControllerAvailableSearch400,
  DashboardPlatformsControllerAvailableSearch401,
  DashboardPlatformsControllerAvailableSearch429,
  DashboardPlatformsControllerAvailableSearchParams,
  DashboardPlatformsControllerCreate400,
  DashboardPlatformsControllerCreate401,
  DashboardPlatformsControllerCreate403,
  DashboardPlatformsControllerCreate404,
  DashboardPlatformsControllerCreate429,
  DashboardPlatformsControllerDetail400,
  DashboardPlatformsControllerDetail401,
  DashboardPlatformsControllerDetail403,
  DashboardPlatformsControllerDetail404,
  DashboardPlatformsControllerDetail429,
  DashboardPlatformsControllerExport400,
  DashboardPlatformsControllerExport401,
  DashboardPlatformsControllerExport413,
  DashboardPlatformsControllerExport429,
  DashboardPlatformsControllerExportParams,
  DashboardPlatformsControllerList400,
  DashboardPlatformsControllerList401,
  DashboardPlatformsControllerList429,
  DashboardPlatformsControllerListParams,
  DashboardPlatformsControllerMeAccessible400,
  DashboardPlatformsControllerMeAccessible401,
  DashboardPlatformsControllerMeAccessible429,
  DashboardPlatformsControllerMeAvailable400,
  DashboardPlatformsControllerMeAvailable401,
  DashboardPlatformsControllerMeAvailable429,
  DashboardPlatformsControllerRefs400,
  DashboardPlatformsControllerRefs401,
  DashboardPlatformsControllerRefs429,
  DashboardPlatformsControllerRefsParams,
  DashboardPlatformsControllerUpdate400,
  DashboardPlatformsControllerUpdate401,
  DashboardPlatformsControllerUpdate403,
  DashboardPlatformsControllerUpdate404,
  DashboardPlatformsControllerUpdate409,
  DashboardPlatformsControllerUpdate429,
  DashboardUpdatePlatformInput,
  PlatformRef,
} from ".././schemas";
import { restClient } from "../../restClient";
import type { ErrorType, BodyType } from "../../restClient";

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * Paginated list of platforms the caller has access to, ordered newest-first by default. Each row carries the id, title and abbreviation, owning federation, configured sports, and lifecycle status. Supports keyword search, ordering, and 1-based pagination.
 * @summary List platforms (dashboard)
 */
export const dashboardPlatformsControllerList = (
  params?: DashboardPlatformsControllerListParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardPlatformList>(
    { url: `/api/dashboard/v1/platforms`, method: "GET", params, signal },
    options
  );
};

export const getDashboardPlatformsControllerListQueryKey = (
  params?: DashboardPlatformsControllerListParams
) => {
  return [`/api/dashboard/v1/platforms`, ...(params ? [params] : [])] as const;
};

export const getDashboardPlatformsControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerList>>,
  TError = ErrorType<
    | DashboardPlatformsControllerList400
    | DashboardPlatformsControllerList401
    | DashboardPlatformsControllerList429
  >,
>(
  params?: DashboardPlatformsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPlatformsControllerList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardPlatformsControllerListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardPlatformsControllerList>>> = ({
    signal,
  }) => dashboardPlatformsControllerList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardPlatformsControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardPlatformsControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPlatformsControllerList>>
>;
export type DashboardPlatformsControllerListQueryError = ErrorType<
  | DashboardPlatformsControllerList400
  | DashboardPlatformsControllerList401
  | DashboardPlatformsControllerList429
>;

export function useDashboardPlatformsControllerList<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerList>>,
  TError = ErrorType<
    | DashboardPlatformsControllerList400
    | DashboardPlatformsControllerList401
    | DashboardPlatformsControllerList429
  >,
>(
  params: undefined | DashboardPlatformsControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPlatformsControllerList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPlatformsControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPlatformsControllerList<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerList>>,
  TError = ErrorType<
    | DashboardPlatformsControllerList400
    | DashboardPlatformsControllerList401
    | DashboardPlatformsControllerList429
  >,
>(
  params?: DashboardPlatformsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPlatformsControllerList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPlatformsControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPlatformsControllerList<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerList>>,
  TError = ErrorType<
    | DashboardPlatformsControllerList400
    | DashboardPlatformsControllerList401
    | DashboardPlatformsControllerList429
  >,
>(
  params?: DashboardPlatformsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPlatformsControllerList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List platforms (dashboard)
 */

export function useDashboardPlatformsControllerList<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerList>>,
  TError = ErrorType<
    | DashboardPlatformsControllerList400
    | DashboardPlatformsControllerList401
    | DashboardPlatformsControllerList429
  >,
>(
  params?: DashboardPlatformsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPlatformsControllerList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardPlatformsControllerListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a platform atomically from the admin Create Platform wizard. The core identity/config fields are required: `title`, `type`, `abbreviation`, `sportIds` (non-empty), `geoScope`, `timeZone`, `languages` (non-empty), plus `ownerId` and `dataOwnerId` (both `fed_…` federation public ids). Remaining fields are optional so partial-but-valid wizard state can be submitted. Sports and `thirdPartyLicenseIds` are numeric ids; `thirdPartyLicenseIds` is the complete enabled-connection selection and `[]` means none. Branding assets are storage file ids (`*FileId`); `countries` / `languages` / `currencies` are arrays. Fee overrides are configured only after creation through the update endpoint. Restricted to superAdmin. Returns the same detail shape as `GET /platforms/:id` so the FE can populate the edit page without a follow-up request.
 * @summary Create platform (dashboard)
 */
export const dashboardPlatformsControllerCreate = (
  dashboardCreatePlatform: BodyType<DashboardCreatePlatform>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardPlatformDetail>(
    {
      url: `/api/dashboard/v1/platforms`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardCreatePlatform,
      signal,
    },
    options
  );
};

export const getDashboardPlatformsControllerCreateMutationOptions = <
  TError = ErrorType<
    | DashboardPlatformsControllerCreate400
    | DashboardPlatformsControllerCreate401
    | DashboardPlatformsControllerCreate403
    | DashboardPlatformsControllerCreate404
    | DashboardPlatformsControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPlatformsControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreatePlatform> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardPlatformsControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreatePlatform> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardPlatformsControllerCreate>>,
    { data: BodyType<DashboardCreatePlatform> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardPlatformsControllerCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardPlatformsControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPlatformsControllerCreate>>
>;
export type DashboardPlatformsControllerCreateMutationBody = BodyType<DashboardCreatePlatform>;
export type DashboardPlatformsControllerCreateMutationError = ErrorType<
  | DashboardPlatformsControllerCreate400
  | DashboardPlatformsControllerCreate401
  | DashboardPlatformsControllerCreate403
  | DashboardPlatformsControllerCreate404
  | DashboardPlatformsControllerCreate429
>;

/**
 * @summary Create platform (dashboard)
 */
export const useDashboardPlatformsControllerCreate = <
  TError = ErrorType<
    | DashboardPlatformsControllerCreate400
    | DashboardPlatformsControllerCreate401
    | DashboardPlatformsControllerCreate403
    | DashboardPlatformsControllerCreate404
    | DashboardPlatformsControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPlatformsControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreatePlatform> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardPlatformsControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreatePlatform> },
  TContext
> => {
  const mutationOptions = getDashboardPlatformsControllerCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Paginated keyword search across platforms the caller has manager / owner access to. Default returns slim `PlatformRef[]` (`id`, `title`, `logo`).

Pass `include=fees,owner` to receive the `DashboardPlatformAccessible` projection inline (collapses the FE search → byId waterfall on the org-create form).

Pass `federationIds=…` to narrow to platforms owned by specific federations. The filter is intersected with the caller's accessible scope, so federations outside that scope drop out silently.

Pass `capabilities=…` to narrow to platforms on which the caller holds at least one of the listed RBAC capabilities (union across values). The capability universe is connection-aware: TARGET platforms whose ACTIVE platform connections (requested by a capability-holding platform of the caller) admit one of the listed capabilities are included, so a connected manager can pick the data-owner platform as a list filter. When absent, the options default to the RBAC membership universe — platforms where the caller holds any role assignment or direct capability grant; that membership universe is NOT connection-aware. No-op for admins.
 * @summary Platform typeahead search — accessible scope (dashboard)
 */
export const dashboardPlatformsControllerAccessibleSearch = (
  params?: DashboardPlatformsControllerAccessibleSearchParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardPlatformsControllerAccessibleSearch200>(
    { url: `/api/dashboard/v1/platforms/accessible/search`, method: "GET", params, signal },
    options
  );
};

export const getDashboardPlatformsControllerAccessibleSearchQueryKey = (
  params?: DashboardPlatformsControllerAccessibleSearchParams
) => {
  return [`/api/dashboard/v1/platforms/accessible/search`, ...(params ? [params] : [])] as const;
};

export const getDashboardPlatformsControllerAccessibleSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleSearch>>,
  TError = ErrorType<
    | DashboardPlatformsControllerAccessibleSearch400
    | DashboardPlatformsControllerAccessibleSearch401
    | DashboardPlatformsControllerAccessibleSearch429
  >,
>(
  params?: DashboardPlatformsControllerAccessibleSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleSearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardPlatformsControllerAccessibleSearchQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleSearch>>
  > = ({ signal }) => dashboardPlatformsControllerAccessibleSearch(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleSearch>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardPlatformsControllerAccessibleSearchQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleSearch>>
>;
export type DashboardPlatformsControllerAccessibleSearchQueryError = ErrorType<
  | DashboardPlatformsControllerAccessibleSearch400
  | DashboardPlatformsControllerAccessibleSearch401
  | DashboardPlatformsControllerAccessibleSearch429
>;

export function useDashboardPlatformsControllerAccessibleSearch<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleSearch>>,
  TError = ErrorType<
    | DashboardPlatformsControllerAccessibleSearch400
    | DashboardPlatformsControllerAccessibleSearch401
    | DashboardPlatformsControllerAccessibleSearch429
  >,
>(
  params: undefined | DashboardPlatformsControllerAccessibleSearchParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleSearch>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleSearch>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPlatformsControllerAccessibleSearch<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleSearch>>,
  TError = ErrorType<
    | DashboardPlatformsControllerAccessibleSearch400
    | DashboardPlatformsControllerAccessibleSearch401
    | DashboardPlatformsControllerAccessibleSearch429
  >,
>(
  params?: DashboardPlatformsControllerAccessibleSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleSearch>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleSearch>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPlatformsControllerAccessibleSearch<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleSearch>>,
  TError = ErrorType<
    | DashboardPlatformsControllerAccessibleSearch400
    | DashboardPlatformsControllerAccessibleSearch401
    | DashboardPlatformsControllerAccessibleSearch429
  >,
>(
  params?: DashboardPlatformsControllerAccessibleSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleSearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Platform typeahead search — accessible scope (dashboard)
 */

export function useDashboardPlatformsControllerAccessibleSearch<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleSearch>>,
  TError = ErrorType<
    | DashboardPlatformsControllerAccessibleSearch400
    | DashboardPlatformsControllerAccessibleSearch401
    | DashboardPlatformsControllerAccessibleSearch429
  >,
>(
  params?: DashboardPlatformsControllerAccessibleSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleSearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardPlatformsControllerAccessibleSearchQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Total platforms the caller manages. The FE uses this to decide whether to render the platform filter at all (hide when `total === 0`).

Pass `capabilities=…` to count the SAME universe the `accessible/search` picker offers for those keys — the connection-aware, federation-derived RBAC capability universe (RBAC full platforms ∪ pair grants incl. `viaConnection` ∪ platforms linked to full-org federations). This keeps filter visibility in sync with the picker: a caller whose platforms come via connections or federation-level grants would otherwise see the picker populated but the filter hidden. No-op for admins (unrestricted callers fall back to the full membership count). When absent, the legacy membership count is returned unchanged.
 * @summary Platform count — accessible scope (dashboard)
 */
export const dashboardPlatformsControllerAccessibleCount = (
  params?: DashboardPlatformsControllerAccessibleCountParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardPlatformCountResult>(
    { url: `/api/dashboard/v1/platforms/accessible/count`, method: "GET", params, signal },
    options
  );
};

export const getDashboardPlatformsControllerAccessibleCountQueryKey = (
  params?: DashboardPlatformsControllerAccessibleCountParams
) => {
  return [`/api/dashboard/v1/platforms/accessible/count`, ...(params ? [params] : [])] as const;
};

export const getDashboardPlatformsControllerAccessibleCountQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleCount>>,
  TError = ErrorType<
    | DashboardPlatformsControllerAccessibleCount400
    | DashboardPlatformsControllerAccessibleCount401
    | DashboardPlatformsControllerAccessibleCount429
  >,
>(
  params?: DashboardPlatformsControllerAccessibleCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleCount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardPlatformsControllerAccessibleCountQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleCount>>
  > = ({ signal }) => dashboardPlatformsControllerAccessibleCount(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardPlatformsControllerAccessibleCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleCount>>
>;
export type DashboardPlatformsControllerAccessibleCountQueryError = ErrorType<
  | DashboardPlatformsControllerAccessibleCount400
  | DashboardPlatformsControllerAccessibleCount401
  | DashboardPlatformsControllerAccessibleCount429
>;

export function useDashboardPlatformsControllerAccessibleCount<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleCount>>,
  TError = ErrorType<
    | DashboardPlatformsControllerAccessibleCount400
    | DashboardPlatformsControllerAccessibleCount401
    | DashboardPlatformsControllerAccessibleCount429
  >,
>(
  params: undefined | DashboardPlatformsControllerAccessibleCountParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleCount>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleCount>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPlatformsControllerAccessibleCount<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleCount>>,
  TError = ErrorType<
    | DashboardPlatformsControllerAccessibleCount400
    | DashboardPlatformsControllerAccessibleCount401
    | DashboardPlatformsControllerAccessibleCount429
  >,
>(
  params?: DashboardPlatformsControllerAccessibleCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleCount>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleCount>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPlatformsControllerAccessibleCount<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleCount>>,
  TError = ErrorType<
    | DashboardPlatformsControllerAccessibleCount400
    | DashboardPlatformsControllerAccessibleCount401
    | DashboardPlatformsControllerAccessibleCount429
  >,
>(
  params?: DashboardPlatformsControllerAccessibleCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleCount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Platform count — accessible scope (dashboard)
 */

export function useDashboardPlatformsControllerAccessibleCount<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleCount>>,
  TError = ErrorType<
    | DashboardPlatformsControllerAccessibleCount400
    | DashboardPlatformsControllerAccessibleCount401
    | DashboardPlatformsControllerAccessibleCount429
  >,
>(
  params?: DashboardPlatformsControllerAccessibleCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPlatformsControllerAccessibleCount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardPlatformsControllerAccessibleCountQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the **accessible** Platform projection for the caller's first managed row — the cold-start source for admin / management surfaces. Use this when the user is in admin mode and needs the full configuration shape (fees, status, full sport detail, full owner record).

Response shape: `DashboardPlatformAccessible` — the same shape returned by `/accessible/search?include=fees,owner`. Distinct from `DashboardPlatformAvailable` to keep the audience boundary explicit in code and OpenAPI.

**FE contract: branch on HTTP status, not on the body.** `200` carries the accessible projection; `204 No Content` means the caller manages zero platforms.
 * @summary Caller's default accessible platform (admin cold-start)
 */
export const dashboardPlatformsControllerMeAccessible = (
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardPlatformAccessible | void>(
    { url: `/api/dashboard/v1/platforms/me/accessible`, method: "GET", signal },
    options
  );
};

export const getDashboardPlatformsControllerMeAccessibleQueryKey = () => {
  return [`/api/dashboard/v1/platforms/me/accessible`] as const;
};

export const getDashboardPlatformsControllerMeAccessibleQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerMeAccessible>>,
  TError = ErrorType<
    | DashboardPlatformsControllerMeAccessible400
    | DashboardPlatformsControllerMeAccessible401
    | DashboardPlatformsControllerMeAccessible429
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof dashboardPlatformsControllerMeAccessible>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof restClient>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardPlatformsControllerMeAccessibleQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardPlatformsControllerMeAccessible>>
  > = ({ signal }) => dashboardPlatformsControllerMeAccessible(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardPlatformsControllerMeAccessible>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardPlatformsControllerMeAccessibleQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPlatformsControllerMeAccessible>>
>;
export type DashboardPlatformsControllerMeAccessibleQueryError = ErrorType<
  | DashboardPlatformsControllerMeAccessible400
  | DashboardPlatformsControllerMeAccessible401
  | DashboardPlatformsControllerMeAccessible429
>;

export function useDashboardPlatformsControllerMeAccessible<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerMeAccessible>>,
  TError = ErrorType<
    | DashboardPlatformsControllerMeAccessible400
    | DashboardPlatformsControllerMeAccessible401
    | DashboardPlatformsControllerMeAccessible429
  >,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof dashboardPlatformsControllerMeAccessible>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof dashboardPlatformsControllerMeAccessible>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof restClient>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPlatformsControllerMeAccessible<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerMeAccessible>>,
  TError = ErrorType<
    | DashboardPlatformsControllerMeAccessible400
    | DashboardPlatformsControllerMeAccessible401
    | DashboardPlatformsControllerMeAccessible429
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof dashboardPlatformsControllerMeAccessible>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof dashboardPlatformsControllerMeAccessible>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof restClient>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPlatformsControllerMeAccessible<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerMeAccessible>>,
  TError = ErrorType<
    | DashboardPlatformsControllerMeAccessible400
    | DashboardPlatformsControllerMeAccessible401
    | DashboardPlatformsControllerMeAccessible429
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof dashboardPlatformsControllerMeAccessible>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof restClient>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Caller's default accessible platform (admin cold-start)
 */

export function useDashboardPlatformsControllerMeAccessible<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerMeAccessible>>,
  TError = ErrorType<
    | DashboardPlatformsControllerMeAccessible400
    | DashboardPlatformsControllerMeAccessible401
    | DashboardPlatformsControllerMeAccessible429
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof dashboardPlatformsControllerMeAccessible>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof restClient>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardPlatformsControllerMeAccessibleQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Paginated keyword search across platforms the caller has any relation with (entered, registered, paid for, etc.). Returns slim `PlatformRef[]` (`id`, `title`, `logo`) — no rich variant.

The rich available shape lives at `GET /platforms/me/available` as a single-record cold-start endpoint; the available picker only needs labels.
 * @summary Platform typeahead search — available scope (dashboard)
 */
export const dashboardPlatformsControllerAvailableSearch = (
  params?: DashboardPlatformsControllerAvailableSearchParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardPlatformSearchResult>(
    { url: `/api/dashboard/v1/platforms/available/search`, method: "GET", params, signal },
    options
  );
};

export const getDashboardPlatformsControllerAvailableSearchQueryKey = (
  params?: DashboardPlatformsControllerAvailableSearchParams
) => {
  return [`/api/dashboard/v1/platforms/available/search`, ...(params ? [params] : [])] as const;
};

export const getDashboardPlatformsControllerAvailableSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableSearch>>,
  TError = ErrorType<
    | DashboardPlatformsControllerAvailableSearch400
    | DashboardPlatformsControllerAvailableSearch401
    | DashboardPlatformsControllerAvailableSearch429
  >,
>(
  params?: DashboardPlatformsControllerAvailableSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableSearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardPlatformsControllerAvailableSearchQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableSearch>>
  > = ({ signal }) => dashboardPlatformsControllerAvailableSearch(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableSearch>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardPlatformsControllerAvailableSearchQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableSearch>>
>;
export type DashboardPlatformsControllerAvailableSearchQueryError = ErrorType<
  | DashboardPlatformsControllerAvailableSearch400
  | DashboardPlatformsControllerAvailableSearch401
  | DashboardPlatformsControllerAvailableSearch429
>;

export function useDashboardPlatformsControllerAvailableSearch<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableSearch>>,
  TError = ErrorType<
    | DashboardPlatformsControllerAvailableSearch400
    | DashboardPlatformsControllerAvailableSearch401
    | DashboardPlatformsControllerAvailableSearch429
  >,
>(
  params: undefined | DashboardPlatformsControllerAvailableSearchParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableSearch>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableSearch>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPlatformsControllerAvailableSearch<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableSearch>>,
  TError = ErrorType<
    | DashboardPlatformsControllerAvailableSearch400
    | DashboardPlatformsControllerAvailableSearch401
    | DashboardPlatformsControllerAvailableSearch429
  >,
>(
  params?: DashboardPlatformsControllerAvailableSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableSearch>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableSearch>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPlatformsControllerAvailableSearch<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableSearch>>,
  TError = ErrorType<
    | DashboardPlatformsControllerAvailableSearch400
    | DashboardPlatformsControllerAvailableSearch401
    | DashboardPlatformsControllerAvailableSearch429
  >,
>(
  params?: DashboardPlatformsControllerAvailableSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableSearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Platform typeahead search — available scope (dashboard)
 */

export function useDashboardPlatformsControllerAvailableSearch<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableSearch>>,
  TError = ErrorType<
    | DashboardPlatformsControllerAvailableSearch400
    | DashboardPlatformsControllerAvailableSearch401
    | DashboardPlatformsControllerAvailableSearch429
  >,
>(
  params?: DashboardPlatformsControllerAvailableSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableSearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardPlatformsControllerAvailableSearchQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Total platforms the caller has any relation with. The FE uses this to decide whether to render the platform filter at all (hide when `total === 0`).
 * @summary Platform count — available scope (dashboard)
 */
export const dashboardPlatformsControllerAvailableCount = (
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardPlatformCountResult>(
    { url: `/api/dashboard/v1/platforms/available/count`, method: "GET", signal },
    options
  );
};

export const getDashboardPlatformsControllerAvailableCountQueryKey = () => {
  return [`/api/dashboard/v1/platforms/available/count`] as const;
};

export const getDashboardPlatformsControllerAvailableCountQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableCount>>,
  TError = ErrorType<
    | DashboardPlatformsControllerAvailableCount400
    | DashboardPlatformsControllerAvailableCount401
    | DashboardPlatformsControllerAvailableCount429
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableCount>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof restClient>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardPlatformsControllerAvailableCountQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableCount>>
  > = ({ signal }) => dashboardPlatformsControllerAvailableCount(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardPlatformsControllerAvailableCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableCount>>
>;
export type DashboardPlatformsControllerAvailableCountQueryError = ErrorType<
  | DashboardPlatformsControllerAvailableCount400
  | DashboardPlatformsControllerAvailableCount401
  | DashboardPlatformsControllerAvailableCount429
>;

export function useDashboardPlatformsControllerAvailableCount<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableCount>>,
  TError = ErrorType<
    | DashboardPlatformsControllerAvailableCount400
    | DashboardPlatformsControllerAvailableCount401
    | DashboardPlatformsControllerAvailableCount429
  >,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableCount>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableCount>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof restClient>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPlatformsControllerAvailableCount<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableCount>>,
  TError = ErrorType<
    | DashboardPlatformsControllerAvailableCount400
    | DashboardPlatformsControllerAvailableCount401
    | DashboardPlatformsControllerAvailableCount429
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableCount>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableCount>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof restClient>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPlatformsControllerAvailableCount<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableCount>>,
  TError = ErrorType<
    | DashboardPlatformsControllerAvailableCount400
    | DashboardPlatformsControllerAvailableCount401
    | DashboardPlatformsControllerAvailableCount429
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableCount>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof restClient>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Platform count — available scope (dashboard)
 */

export function useDashboardPlatformsControllerAvailableCount<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableCount>>,
  TError = ErrorType<
    | DashboardPlatformsControllerAvailableCount400
    | DashboardPlatformsControllerAvailableCount401
    | DashboardPlatformsControllerAvailableCount429
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableCount>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof restClient>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardPlatformsControllerAvailableCountQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the **available** Platform projection for the caller's first available row — the cold-start source for `CurrentPlatformContext`. Use this when the user is in normal (non-admin) mode and just needs the platform shell (branding, locales, sport list, owner attribution).

Response shape: `DashboardPlatformAvailable` — intentionally narrower than the accessible variant. Fees, status, type, geoScope, and other admin-only fields are not exposed here; they live on `/me/accessible`.

Includes `capabilities` — the RBAC capability keys the caller holds on the platform's PLATFORM node — so the FE can gate platform-scoped controls (platform settings, create leagues / organizations, …) without a follow-up request.

**FE contract: branch on HTTP status, not on the body.** `200` carries the available projection; `204 No Content` means the caller has zero available platforms.
 * @summary Caller's default available platform (cold-start bootstrap)
 */
export const dashboardPlatformsControllerMeAvailable = (
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardPlatformAvailable | void>(
    { url: `/api/dashboard/v1/platforms/me/available`, method: "GET", signal },
    options
  );
};

export const getDashboardPlatformsControllerMeAvailableQueryKey = () => {
  return [`/api/dashboard/v1/platforms/me/available`] as const;
};

export const getDashboardPlatformsControllerMeAvailableQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerMeAvailable>>,
  TError = ErrorType<
    | DashboardPlatformsControllerMeAvailable400
    | DashboardPlatformsControllerMeAvailable401
    | DashboardPlatformsControllerMeAvailable429
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof dashboardPlatformsControllerMeAvailable>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof restClient>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardPlatformsControllerMeAvailableQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardPlatformsControllerMeAvailable>>
  > = ({ signal }) => dashboardPlatformsControllerMeAvailable(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardPlatformsControllerMeAvailable>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardPlatformsControllerMeAvailableQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPlatformsControllerMeAvailable>>
>;
export type DashboardPlatformsControllerMeAvailableQueryError = ErrorType<
  | DashboardPlatformsControllerMeAvailable400
  | DashboardPlatformsControllerMeAvailable401
  | DashboardPlatformsControllerMeAvailable429
>;

export function useDashboardPlatformsControllerMeAvailable<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerMeAvailable>>,
  TError = ErrorType<
    | DashboardPlatformsControllerMeAvailable400
    | DashboardPlatformsControllerMeAvailable401
    | DashboardPlatformsControllerMeAvailable429
  >,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof dashboardPlatformsControllerMeAvailable>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof dashboardPlatformsControllerMeAvailable>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof restClient>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPlatformsControllerMeAvailable<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerMeAvailable>>,
  TError = ErrorType<
    | DashboardPlatformsControllerMeAvailable400
    | DashboardPlatformsControllerMeAvailable401
    | DashboardPlatformsControllerMeAvailable429
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof dashboardPlatformsControllerMeAvailable>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof dashboardPlatformsControllerMeAvailable>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof restClient>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPlatformsControllerMeAvailable<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerMeAvailable>>,
  TError = ErrorType<
    | DashboardPlatformsControllerMeAvailable400
    | DashboardPlatformsControllerMeAvailable401
    | DashboardPlatformsControllerMeAvailable429
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof dashboardPlatformsControllerMeAvailable>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof restClient>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Caller's default available platform (cold-start bootstrap)
 */

export function useDashboardPlatformsControllerMeAvailable<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerMeAvailable>>,
  TError = ErrorType<
    | DashboardPlatformsControllerMeAvailable400
    | DashboardPlatformsControllerMeAvailable401
    | DashboardPlatformsControllerMeAvailable429
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof dashboardPlatformsControllerMeAvailable>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof restClient>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardPlatformsControllerMeAvailableQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the **available** Platform projection for the requested platform. Replaces the legacy GraphQL `availablePlatformById` query — same audience, same shape (`DashboardPlatformAvailable`).

The platform is identified by its canonical `plt_…` public id. The caller's available set is checked on the server; platforms outside that set return `404 NOT_FOUND` rather than 403 — the slim row's existence isn't sensitive, but the rich projection is per-caller.

Includes `capabilities` — the RBAC capability keys the caller holds on the platform's PLATFORM node — so the FE can gate platform-scoped controls (platform settings, create leagues / organizations, …) without a follow-up request.
 * @summary Platform by public id — available scope (dashboard)
 */
export const dashboardPlatformsControllerAvailableByPublicId = (
  id: string,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardPlatformAvailable>(
    { url: `/api/dashboard/v1/platforms/available/${id}`, method: "GET", signal },
    options
  );
};

export const getDashboardPlatformsControllerAvailableByPublicIdQueryKey = (id: string) => {
  return [`/api/dashboard/v1/platforms/available/${id}`] as const;
};

export const getDashboardPlatformsControllerAvailableByPublicIdQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableByPublicId>>,
  TError = ErrorType<
    | DashboardPlatformsControllerAvailableByPublicId400
    | DashboardPlatformsControllerAvailableByPublicId401
    | DashboardPlatformsControllerAvailableByPublicId404
    | DashboardPlatformsControllerAvailableByPublicId429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableByPublicId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardPlatformsControllerAvailableByPublicIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableByPublicId>>
  > = ({ signal }) => dashboardPlatformsControllerAvailableByPublicId(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableByPublicId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardPlatformsControllerAvailableByPublicIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableByPublicId>>
>;
export type DashboardPlatformsControllerAvailableByPublicIdQueryError = ErrorType<
  | DashboardPlatformsControllerAvailableByPublicId400
  | DashboardPlatformsControllerAvailableByPublicId401
  | DashboardPlatformsControllerAvailableByPublicId404
  | DashboardPlatformsControllerAvailableByPublicId429
>;

export function useDashboardPlatformsControllerAvailableByPublicId<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableByPublicId>>,
  TError = ErrorType<
    | DashboardPlatformsControllerAvailableByPublicId400
    | DashboardPlatformsControllerAvailableByPublicId401
    | DashboardPlatformsControllerAvailableByPublicId404
    | DashboardPlatformsControllerAvailableByPublicId429
  >,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableByPublicId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableByPublicId>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPlatformsControllerAvailableByPublicId<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableByPublicId>>,
  TError = ErrorType<
    | DashboardPlatformsControllerAvailableByPublicId400
    | DashboardPlatformsControllerAvailableByPublicId401
    | DashboardPlatformsControllerAvailableByPublicId404
    | DashboardPlatformsControllerAvailableByPublicId429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableByPublicId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableByPublicId>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPlatformsControllerAvailableByPublicId<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableByPublicId>>,
  TError = ErrorType<
    | DashboardPlatformsControllerAvailableByPublicId400
    | DashboardPlatformsControllerAvailableByPublicId401
    | DashboardPlatformsControllerAvailableByPublicId404
    | DashboardPlatformsControllerAvailableByPublicId429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableByPublicId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Platform by public id — available scope (dashboard)
 */

export function useDashboardPlatformsControllerAvailableByPublicId<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableByPublicId>>,
  TError = ErrorType<
    | DashboardPlatformsControllerAvailableByPublicId400
    | DashboardPlatformsControllerAvailableByPublicId401
    | DashboardPlatformsControllerAvailableByPublicId404
    | DashboardPlatformsControllerAvailableByPublicId429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPlatformsControllerAvailableByPublicId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardPlatformsControllerAvailableByPublicIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Batched id → ref lookup for filter-chip rehydration. Returns slim, public-safe identity fields (`id`, `title`, `logo`). Not scope-restricted — chips need to render labels for ids the caller may have saved before a scope change. Missing ids are simply absent from the response.
 * @summary Resolve platform refs by id (dashboard)
 */
export const dashboardPlatformsControllerRefs = (
  params: DashboardPlatformsControllerRefsParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<PlatformRef[]>(
    { url: `/api/dashboard/v1/platforms/refs`, method: "GET", params, signal },
    options
  );
};

export const getDashboardPlatformsControllerRefsQueryKey = (
  params: DashboardPlatformsControllerRefsParams
) => {
  return [`/api/dashboard/v1/platforms/refs`, ...(params ? [params] : [])] as const;
};

export const getDashboardPlatformsControllerRefsQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerRefs>>,
  TError = ErrorType<
    | DashboardPlatformsControllerRefs400
    | DashboardPlatformsControllerRefs401
    | DashboardPlatformsControllerRefs429
  >,
>(
  params: DashboardPlatformsControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPlatformsControllerRefs>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardPlatformsControllerRefsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardPlatformsControllerRefs>>> = ({
    signal,
  }) => dashboardPlatformsControllerRefs(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardPlatformsControllerRefs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardPlatformsControllerRefsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPlatformsControllerRefs>>
>;
export type DashboardPlatformsControllerRefsQueryError = ErrorType<
  | DashboardPlatformsControllerRefs400
  | DashboardPlatformsControllerRefs401
  | DashboardPlatformsControllerRefs429
>;

export function useDashboardPlatformsControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerRefs>>,
  TError = ErrorType<
    | DashboardPlatformsControllerRefs400
    | DashboardPlatformsControllerRefs401
    | DashboardPlatformsControllerRefs429
  >,
>(
  params: DashboardPlatformsControllerRefsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPlatformsControllerRefs>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPlatformsControllerRefs>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPlatformsControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerRefs>>,
  TError = ErrorType<
    | DashboardPlatformsControllerRefs400
    | DashboardPlatformsControllerRefs401
    | DashboardPlatformsControllerRefs429
  >,
>(
  params: DashboardPlatformsControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPlatformsControllerRefs>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPlatformsControllerRefs>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPlatformsControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerRefs>>,
  TError = ErrorType<
    | DashboardPlatformsControllerRefs400
    | DashboardPlatformsControllerRefs401
    | DashboardPlatformsControllerRefs429
  >,
>(
  params: DashboardPlatformsControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPlatformsControllerRefs>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Resolve platform refs by id (dashboard)
 */

export function useDashboardPlatformsControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerRefs>>,
  TError = ErrorType<
    | DashboardPlatformsControllerRefs400
    | DashboardPlatformsControllerRefs401
    | DashboardPlatformsControllerRefs429
  >,
>(
  params: DashboardPlatformsControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPlatformsControllerRefs>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardPlatformsControllerRefsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Streamed CSV / XLSX export with filter parity against `GET /platforms`. No pagination; 100k row cap (413 EXPORT_TOO_LARGE). Pass `columns` to select a subset of columns (omit for all).
 * @summary Export platforms (dashboard)
 */
export const dashboardPlatformsControllerExport = (
  params: DashboardPlatformsControllerExportParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<Blob>(
    {
      url: `/api/dashboard/v1/platforms/export`,
      method: "GET",
      params,
      responseType: "blob",
      signal,
    },
    options
  );
};

export const getDashboardPlatformsControllerExportQueryKey = (
  params: DashboardPlatformsControllerExportParams
) => {
  return [`/api/dashboard/v1/platforms/export`, ...(params ? [params] : [])] as const;
};

export const getDashboardPlatformsControllerExportQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerExport>>,
  TError = ErrorType<
    | DashboardPlatformsControllerExport400
    | DashboardPlatformsControllerExport401
    | DashboardPlatformsControllerExport413
    | DashboardPlatformsControllerExport429
  >,
>(
  params: DashboardPlatformsControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPlatformsControllerExport>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardPlatformsControllerExportQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardPlatformsControllerExport>>> = ({
    signal,
  }) => dashboardPlatformsControllerExport(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardPlatformsControllerExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardPlatformsControllerExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPlatformsControllerExport>>
>;
export type DashboardPlatformsControllerExportQueryError = ErrorType<
  | DashboardPlatformsControllerExport400
  | DashboardPlatformsControllerExport401
  | DashboardPlatformsControllerExport413
  | DashboardPlatformsControllerExport429
>;

export function useDashboardPlatformsControllerExport<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerExport>>,
  TError = ErrorType<
    | DashboardPlatformsControllerExport400
    | DashboardPlatformsControllerExport401
    | DashboardPlatformsControllerExport413
    | DashboardPlatformsControllerExport429
  >,
>(
  params: DashboardPlatformsControllerExportParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPlatformsControllerExport>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPlatformsControllerExport>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPlatformsControllerExport<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerExport>>,
  TError = ErrorType<
    | DashboardPlatformsControllerExport400
    | DashboardPlatformsControllerExport401
    | DashboardPlatformsControllerExport413
    | DashboardPlatformsControllerExport429
  >,
>(
  params: DashboardPlatformsControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPlatformsControllerExport>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPlatformsControllerExport>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPlatformsControllerExport<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerExport>>,
  TError = ErrorType<
    | DashboardPlatformsControllerExport400
    | DashboardPlatformsControllerExport401
    | DashboardPlatformsControllerExport413
    | DashboardPlatformsControllerExport429
  >,
>(
  params: DashboardPlatformsControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPlatformsControllerExport>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Export platforms (dashboard)
 */

export function useDashboardPlatformsControllerExport<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerExport>>,
  TError = ErrorType<
    | DashboardPlatformsControllerExport400
    | DashboardPlatformsControllerExport401
    | DashboardPlatformsControllerExport413
    | DashboardPlatformsControllerExport429
  >,
>(
  params: DashboardPlatformsControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPlatformsControllerExport>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardPlatformsControllerExportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Partial update of a platform. Accepts the lifecycle `status` toggle, the platform `documents` / `folders`, the `terminology` configuration, the custom `fees` set, the enabled `thirdPartyLicenseIds`, and the `ownerId` / `dataOwnerId` ownership relations (each a `fed_…` federation public id). `thirdPartyLicenseIds` is a full-set replacement: omit it to preserve the current connections or send `[]` to clear/disable all. Sending either `documents` or `folders` replaces ALL existing documents AND folders (all-or-nothing); omit both to leave them untouched. Sending `terminology` replaces the stored term map wholesale; omit to leave it untouched. Editing `fees` additionally requires the `PLATFORM_FEE:WRITE` capability on the platform (tournated fee tiers stay superAdmin-only); reassigning `ownerId` / `dataOwnerId` additionally requires `PLATFORM_OWNER:WRITE` — callers lacking the relevant capability receive 403. Returns the same platform detail as `GET /platforms/:id`.
 * @summary Update platform (dashboard)
 */
export const dashboardPlatformsControllerUpdate = (
  id: string,
  dashboardUpdatePlatformInput: BodyType<DashboardUpdatePlatformInput>,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<DashboardPlatformDetail>(
    {
      url: `/api/dashboard/v1/platforms/${id}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: dashboardUpdatePlatformInput,
    },
    options
  );
};

export const getDashboardPlatformsControllerUpdateMutationOptions = <
  TError = ErrorType<
    | DashboardPlatformsControllerUpdate400
    | DashboardPlatformsControllerUpdate401
    | DashboardPlatformsControllerUpdate403
    | DashboardPlatformsControllerUpdate404
    | DashboardPlatformsControllerUpdate409
    | DashboardPlatformsControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPlatformsControllerUpdate>>,
    TError,
    { id: string; data: BodyType<DashboardUpdatePlatformInput> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardPlatformsControllerUpdate>>,
  TError,
  { id: string; data: BodyType<DashboardUpdatePlatformInput> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardPlatformsControllerUpdate>>,
    { id: string; data: BodyType<DashboardUpdatePlatformInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return dashboardPlatformsControllerUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardPlatformsControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPlatformsControllerUpdate>>
>;
export type DashboardPlatformsControllerUpdateMutationBody = BodyType<DashboardUpdatePlatformInput>;
export type DashboardPlatformsControllerUpdateMutationError = ErrorType<
  | DashboardPlatformsControllerUpdate400
  | DashboardPlatformsControllerUpdate401
  | DashboardPlatformsControllerUpdate403
  | DashboardPlatformsControllerUpdate404
  | DashboardPlatformsControllerUpdate409
  | DashboardPlatformsControllerUpdate429
>;

/**
 * @summary Update platform (dashboard)
 */
export const useDashboardPlatformsControllerUpdate = <
  TError = ErrorType<
    | DashboardPlatformsControllerUpdate400
    | DashboardPlatformsControllerUpdate401
    | DashboardPlatformsControllerUpdate403
    | DashboardPlatformsControllerUpdate404
    | DashboardPlatformsControllerUpdate409
    | DashboardPlatformsControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPlatformsControllerUpdate>>,
    TError,
    { id: string; data: BodyType<DashboardUpdatePlatformInput> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardPlatformsControllerUpdate>>,
  TError,
  { id: string; data: BodyType<DashboardUpdatePlatformInput> },
  TContext
> => {
  const mutationOptions = getDashboardPlatformsControllerUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Platform settings detail by public id, including selected `thirdPartyLicenses` refs. Requires the `PLATFORM_SETTINGS:READ` capability on the target platform (held directly, via the platform_manager bundle, the owner / data-owner short-circuit, or an active platform connection exposing the PLATFORM_SETTINGS resource). The `fees` section is additionally gated on `PLATFORM_FEE:READ` at the platform node: callers without it receive `fees: []` while the rest of the detail stays readable. Returns 404 when the platform does not exist; 403 when the caller lacks the capability.
 * @summary Get platform detail (dashboard)
 */
export const dashboardPlatformsControllerDetail = (
  id: string,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardPlatformDetail>(
    { url: `/api/dashboard/v1/platforms/${id}`, method: "GET", signal },
    options
  );
};

export const getDashboardPlatformsControllerDetailQueryKey = (id: string) => {
  return [`/api/dashboard/v1/platforms/${id}`] as const;
};

export const getDashboardPlatformsControllerDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerDetail>>,
  TError = ErrorType<
    | DashboardPlatformsControllerDetail400
    | DashboardPlatformsControllerDetail401
    | DashboardPlatformsControllerDetail403
    | DashboardPlatformsControllerDetail404
    | DashboardPlatformsControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPlatformsControllerDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardPlatformsControllerDetailQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardPlatformsControllerDetail>>> = ({
    signal,
  }) => dashboardPlatformsControllerDetail(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardPlatformsControllerDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardPlatformsControllerDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPlatformsControllerDetail>>
>;
export type DashboardPlatformsControllerDetailQueryError = ErrorType<
  | DashboardPlatformsControllerDetail400
  | DashboardPlatformsControllerDetail401
  | DashboardPlatformsControllerDetail403
  | DashboardPlatformsControllerDetail404
  | DashboardPlatformsControllerDetail429
>;

export function useDashboardPlatformsControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerDetail>>,
  TError = ErrorType<
    | DashboardPlatformsControllerDetail400
    | DashboardPlatformsControllerDetail401
    | DashboardPlatformsControllerDetail403
    | DashboardPlatformsControllerDetail404
    | DashboardPlatformsControllerDetail429
  >,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPlatformsControllerDetail>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPlatformsControllerDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPlatformsControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerDetail>>,
  TError = ErrorType<
    | DashboardPlatformsControllerDetail400
    | DashboardPlatformsControllerDetail401
    | DashboardPlatformsControllerDetail403
    | DashboardPlatformsControllerDetail404
    | DashboardPlatformsControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPlatformsControllerDetail>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPlatformsControllerDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPlatformsControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerDetail>>,
  TError = ErrorType<
    | DashboardPlatformsControllerDetail400
    | DashboardPlatformsControllerDetail401
    | DashboardPlatformsControllerDetail403
    | DashboardPlatformsControllerDetail404
    | DashboardPlatformsControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPlatformsControllerDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get platform detail (dashboard)
 */

export function useDashboardPlatformsControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardPlatformsControllerDetail>>,
  TError = ErrorType<
    | DashboardPlatformsControllerDetail400
    | DashboardPlatformsControllerDetail401
    | DashboardPlatformsControllerDetail403
    | DashboardPlatformsControllerDetail404
    | DashboardPlatformsControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPlatformsControllerDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardPlatformsControllerDetailQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
